import React from 'react';
import styles from '../style.module.scss';

import VehicleImage from 'components/VehicleImage';

const t = {
  meters: 'm',
};

const VehicleType = ({ rowData }) => {
  return (
    <div className={styles.vehicleCell}>
      <VehicleImage type={rowData.vehicle_type} />
      {rowData.container_length && rowData.container_length > 0 ? (
        <span className={styles.smallDetail}>
          {rowData.container_length} {t.meters}
        </span>
      ) : null}
    </div>
  );
};

export default VehicleType;
